export const RESENDT_OTP_DELAY_DURATION_IN_SECONDS = 60 * 1.5